import { render, staticRenderFns } from "./Freight.vue?vue&type=template&id=ee184bf4&scoped=true"
import script from "./Freight.vue?vue&type=script&lang=js"
export * from "./Freight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee184bf4",
  null
  
)

export default component.exports